import { Box, Flex } from 'components/elements'
import { yupResolver } from '@hookform/resolvers/yup'
import { Controller, useForm } from 'react-hook-form'
import { useEffect } from 'react'
import { QuoteStatement, Stages } from 'utils/enum'
import { QuoteProps, QuoteServicesProps } from 'features/quote/components/type'
import { serviceLableAssessments } from 'configs/constants'
import { MenuList } from 'components/sidebarLayout/Sidebar/SidebarMenu'
import { CheckBoxInput, Form, Label, userRegHeadingCss } from 'views/style'
import { step1Schema } from 'features/quote/components/GetAQuoteProcess/ServiceFormBase'
import { BackNavArrowIcon } from 'components/icons'
import { QouteLayout } from 'features/quote/page/GetAQuotes'
import { formatServiceName } from 'utils/function'
import { ChangePolicyFormButtons } from './PolicyCoveragePlan'
import { PrimaryService_ID } from 'features/incidents/components/enums'
import { TERMINOLOGY } from 'utils/enum'

export const PolicyServiceFormBase = ({ props, stage }: { props: QuoteProps; stage: Stages }) => {
  const { quoteUserReg, setQuoteUserReg, setStage, setOpenModal } = props
  const secondaryServices = quoteUserReg?.secondaryservices
  const primaryService = quoteUserReg?.primaryService
  const discount = quoteUserReg?.discount || 0
  const { handleSubmit, control, setValue } = useForm<QuoteServicesProps>({
    resolver: yupResolver(step1Schema),
    defaultValues: {
      service: [],
    },
  })

  useEffect(() => {
    //all the services
    const services = quoteUserReg && quoteUserReg?.service
    //settting the value of checkboxes if already checked
    if (services) {
      services.forEach(item => {
        setValue(`service.${item}`, item)
      })
    } else {
      //   default checked if micro secure service
      if (secondaryServices) {
        secondaryServices.forEach(service => {
          if (service.id === PrimaryService_ID.SECURE) {
            setValue(`service.${service.id}`, service.id)
          }
        })
      }
    }
  }, [quoteUserReg, secondaryServices, setValue])

  const onSubmit = (data: QuoteServicesProps) => {
    //filter out the services should not be null,undefined and should not have primaryservice
    let services = (data?.service && data?.service.filter(item => item !== null && item !== undefined)) || []
    services = services.filter(item => item !== primaryService?.id)

    if (primaryService) {
      services = [...services, primaryService?.id]
    }
    const obj = {
      ...quoteUserReg,
      service: services,
      discount: discount,
    }
    setQuoteUserReg && setQuoteUserReg(obj)
    setStage && setStage(stage)
  }

  return (
    <>
      <Flex align="center">
        <BackNavArrowIcon fontSize={24} style={{ cursor: 'pointer' }} onClick={() => setStage && setStage(Stages.STAGE1)} />

        <Flex as="h2" justify={'center'} css={userRegHeadingCss}>
          Change {TERMINOLOGY.warranty.singular}
        </Flex>
      </Flex>
      <Flex align="start" css={{ ...QouteLayout }}>
        <Form onSubmit={handleSubmit(onSubmit)} css={{ width: '100%' }}>
          <Box css={{ textAlign: 'left' }}>
            {secondaryServices && secondaryServices.length > 0 && <Box css={{ fontSize: '1rem', mb: '1rem', color: '$primary' }}>{QuoteStatement.STEP2}</Box>}
            {/* primary services */}

            <Box>
              <Box as="h4" css={{ paddingLeft: 0, fontWeight: '$bold' }}>
                Primary
              </Box>
              {primaryService && (
                <MenuList>
                  <Label key={primaryService?.name}>
                    <CheckBoxInput type="checkbox" value={primaryService?.id} data-state={'checked'} disabled />
                    <Box as="p" css={{ fontWeight: '$bold' }}>
                      {serviceLableAssessments[formatServiceName(primaryService?.name ?? '')]} -&nbsp;
                      <Box as="span">{formatServiceName(primaryService?.name ?? '')}</Box>
                    </Box>
                  </Label>
                </MenuList>
              )}
            </Box>
            {/* sceondary Services */}
            {secondaryServices && secondaryServices.length > 0 && (
              <Box>
                <Box as="h4" css={{ paddingLeft: 0, fontWeight: '$bold' }}>
                  Add-ons
                </Box>

                {secondaryServices?.map(
                  (secondaryService, idx) =>
                    // service
                    secondaryService?.id !== primaryService?.id && (
                      <MenuList key={idx}>
                        <Label key={secondaryService.name}>
                          <Controller
                            name={`service.${secondaryService.id}`}
                            control={control}
                            render={({ field }) => (
                              <CheckBoxInput
                                type="checkbox"
                                value={secondaryService.value}
                                checked={field.value === secondaryService.id}
                                onChange={() => {
                                  const newFieldValue = field.value === secondaryService.id ? null : secondaryService.id
                                  field.onChange(newFieldValue) // Update the field value
                                }}
                                data-state={field.value === secondaryService.id ? 'checked' : 'unchecked'}
                              />
                            )}
                          />
                          <Box as="p" css={{ fontWeight: '$bold' }}>
                            {serviceLableAssessments[formatServiceName(secondaryService?.name ?? '')]} -&nbsp;
                            <Box as="span">{formatServiceName(secondaryService?.name ?? '')}</Box>
                          </Box>
                        </Label>
                      </MenuList>
                    )
                )}
              </Box>
            )}
          </Box>

          <ChangePolicyFormButtons setOpenModal={setOpenModal} setStage={setStage} setQuoteUserReg={setQuoteUserReg} />
        </Form>
      </Flex>
    </>
  )
}
